import React, { Component } from 'react';
import { withRouter, } from 'react-router-dom';
import { detailAPI } from '../../api/parl.js'
import '../../assets/css/common.css'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'
class parlDetail extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dataSource: [],
			currMeeting: '',
			currCountry: '',
		}
	}

	componentDidMount(){
		this.setState({currCountry: this.props.match.params.country, currMeeting: this.props.match.params.id}, () => {this.fetchDetail()})
	}
	
	fetchDetail = () => {
		const { currMeeting } = this.state;
		var params = { auto_id: currMeeting }
		detailAPI('ca', params)
			.then(res => {
				var data = res.data.data
				
				this.setState({dataSource: data})
			})
	}

	render() {
		const { dataSource } = this.state;
		const contentEle = dataSource.main_topics ?
			(dataSource.main_topics.map((major_record, major_index) => 
				<div key={major_index}>
					<div className="minor-heading" style={{ color: '#333333', marginTop: 20 }}>Major Topic: {major_record.main_topic}</div>
					{major_record.speeches.map((speech_record, speech_index) => 
						<div key={speech_index}>
							<div style={{textIndent: '1em', fontSize: 18, fontWeight: 'bold'}} >
								Speaker: {speech_record.speaker_name}
							</div>
                            <div className="main-text" style={{ color: '#333333', marginLeft: '2em', textIndent: '1em' }}>{speech_record.speech_text}</div>

							{/* {speech_record.second_level_paras.map((content, content_index) => 
								<div key={content_index} className="main-text" style={{ color: '#333333', textIndent: '2em', fontWeight: 'bold', marginBottom: 10}}>
									Speaker: {content.speaker_name}
									{content.contents.map((para, para_index) => 
										<div key={para_index} className="main-text" style={{ color: '#333333', marginLeft: '2em', textIndent: '2em' }}>{para}</div>
									)}
								</div>
							)} */}
						</div>
					)}
				</div>
			)) : <></>
		return (
            <div style={{ margin: '40px 15%', }}>
			<MyBreadcrumb urls={[
				{ url: '/database/parl/canada', breadcrumbName:  '加拿大议会数据库' },
				{ breadcrumbName: '详情' },
			]} />
				<div className="major-heading" style={{  textAlign: 'center', color: '#333333', marginTop: 20 }}>{dataSource.post_date}</div>
				{/* <div className="minor-heading" style={{ textAlign: 'center', color: '#333333', marginTop: 20 }}>{dataSource.type}</div> */}
				{contentEle}
			</div>
		);
	}
}

export default withRouter(parlDetail)
